export const createBrewMenuMenu = /* GraphQL */ `mutation CreateBrewMenu($input: inputCreateBrewMenu!) {
	createBrewMenu(input: $input){
		id
		title
	}
}`
